import slice from './analysesVisitsSlice';

export const {
  updateAnalysisVisitStatus,
  renameAnalysisVisit,
  populateAnalysesVisits,
  recordAnalysisVisit,
  resetAnalysesVisits,
} = slice.actions;

export default slice.reducer;
